import {Alert, AlertTitle, Backdrop, Box, useMediaQuery} from '@mui/material';
import {useEffect, useState} from "react";
import {useDocumentTranslation} from "../documents/documentContext";

export const RotateDeviceWarningOverlay = () => {

    const t = useDocumentTranslation();

    const isPortrait = useMediaQuery('(orientation: portrait)');

    const isMobile = useMediaQuery('(max-width: 600px)');

    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(isPortrait && isMobile);
    }, [isPortrait, isMobile]);

    return (
        <Backdrop
            sx={{color: '#fff', zIndex: 9999}}
            open={open}
        >
            <Box sx={{maxWidth: 400}}>
                <Alert
                    severity="warning"
                    variant="filled"
                >
                    <AlertTitle>
                        {t('rotateDeviceAlertTitle', 'Roter enhet')}
                    </AlertTitle>
                    {t('rotateDeviceAlertText', 'For å kunne se dataene - roter enheten din 90 grader.')}
                </Alert>
            </Box>
        </Backdrop>
    );
};